'use client';

import cn from 'classnames';
import Image from 'next/image';
import React, { useState, useEffect } from 'react';

import image404 from 'public/images/404.svg';
import patynaLogo from 'public/images/patyna_logo.svg';

import '@/styles/globals.scss';
import styles from './styles.module.scss';

const PasswordPromptDialog = () => {
  const [password, setPassword] = useState('');
  const [passwordIncorrect, setPasswordIncorrect] = useState(false);
  const [noPassword, setNoPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const request = await fetch(`/api`, {
      body: JSON.stringify({ password }),
      headers: { 'Content-Type': 'application/json' },
      method: 'post',
    });

    if (password) {
      if (request.status !== 200) {
        return setNoPassword(false), setPasswordIncorrect(true);
      } else {
        window.location.reload();
      }
    } else {
      return setPasswordIncorrect(false), setNoPassword(true);
    }
  };

  useEffect(() => {
    setPassword('');
  }, [passwordIncorrect]);

  return (
    <section className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.col}>
            <Image
              className={cn(styles.logo)}
              src={patynaLogo}
              alt="Patyna - sklep z meblami i dekoracjami vintage"
              width={78}
              priority
            />
            <h2 className={styles.headline}>
              Przerwa techniczna -
              {` ${process.env.NEXT_PUBLIC_MAINTENANCE_MODE_TEXT}`}
            </h2>
            <div className={styles.text}>
              <p>
                Nasz marketplace przechodzi szybką metamorfozę, by już niebawem
                zachwycić Cię jeszcze bardziej.
              </p>
            </div>
            <div className={styles.links}>
              <form
                onSubmit={handleSubmit}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1.6rem',
                }}
              >
                <label
                  htmlFor="password"
                  style={{
                    color: '#000000',
                    fontSize: '22px',
                  }}
                >
                  Hasło:
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  style={{
                    padding: '16px',
                    color: '#000000',
                    fontSize: '16px',
                    appearance: 'none',
                    height: '40px',
                    minWidth: '250px',
                    border: '1px solid #000',
                    borderRadius: '24px',
                  }}
                />
                <button
                  type="submit"
                  style={{
                    padding: '10px 16px',
                    color: '#000000',
                    fontSize: '14px',
                    border: '1px solid #000',
                    borderRadius: '24px',
                    cursor: 'pointer',
                  }}
                >
                  Zaloguj się
                </button>
              </form>
              <div>
                {noPassword && (
                  <p
                    style={{
                      color: 'red',
                      fontSize: '14px',
                    }}
                  >
                    Podaj hasło.
                  </p>
                )}
                {passwordIncorrect && (
                  <p
                    style={{
                      color: 'red',
                      fontSize: '14px',
                    }}
                  >
                    Podane hasło jest niepoprawne.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.imageMobileWrapper}>
          <Image src={image404} alt="Fotel" width={292} height={204} />
        </div>
        <div className={styles.imageWrapper}>
          <Image src={image404} alt="Fotel" width={582} height={407} />
        </div>
      </div>
    </section>
  );
};

export default PasswordPromptDialog;
